import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import SparklesIcon from "../components/icons/SparklesIcon";
import StarIcon from "../components/icons/StarIcon";
import { Link } from "react-router-dom";

// =================================================================================
// FILE: src/pages/HomePage.jsx
// =================================================================================
const HomePage = ({ setPage, openAdvisor }) => {
  // MODIFICACIÓN: Ahora el array contiene objetos para diferenciar tipo de media
  const carouselItems = [
    { type: "image", src: "/images/hero-1.png" },
    { type: "image", src: "/images/hero-2.png" },
    { type: "image", src: "/images/hero-3.jpg" },
    { type: "video", src: "/videos/herov-1.mp4" },
    { type: "image", src: "/images/hero-4.jpg" },
    { type: "image", src: "/images/hero-2-1.png" },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [carouselItems.length]);

  const featuredServices = [
    {
      name: "Borrado de Manchas (Pico Láser)",
      desc: "¿Ya probaste cremas sin éxito? Las manchas hormonales, solares o post-acné necesitan tecnología real. Este tratamiento actúa directamente en la pigmentación. Siéntete segura sin maquillaje.",
      img: "/images/beforeafter-manchas.jpg",
    },
    {
      name: "HIFU 12D (Lifting sin Cirugía)",
      desc: "¿Notas flacidez pero no quieres pasar por cirugía? Esta tecnología de ultrasonido redefine tu rostro de forma natural, recuperando la firmeza que creías perdida. Sin bisturí, sin tiempo de recuperación.",
      img: "/images/beforeafter-hifu.jpg",
    },
    {
      name: "Borrado de Tatuajes y Micropigmentación",
      desc: "Ese tatuaje que ya no te representa o esa micropigmentación fallida que escondes. Te entendemos. Eliminamos de forma segura y definitiva lo que te genera inseguridad.",
      img: "/images/beforeafter-tatuajes.jpg",
    },
  ];
  const testimonials = [
    {
      name: "Ana García",
      quote:
        "Estaba cansada de gastar en cremas que no funcionaban para mis manchas. Aquí me explicaron por qué y cuál era la solución real. Me siento otra persona.",
      rating: 5,
    },
    {
      name: "Carlos Vega",
      quote:
        "Tenía miedo de los tratamientos por una mala experiencia anterior. Aquí me explicaron todo con paciencia y sin presiones. El resultado superó mis expectativas.",
      rating: 5,
    },
  ];

  return (
    <>
      <Helmet>
        {/* Title optimizado para SEO */}
        <title>DermicaPro - Clínica de Cuidado de la Piel | Tratamientos Estéticos Profesionales</title>

        {/* Meta Description optimizada */}
        <meta
          name="description"
          content="Recupera la confianza en tu piel con DermicaPro. Tratamientos profesionales: HIFU 12D, Pico Láser, Exosomas, Botox, Hollywood Peel y más. Tecnología real, resultados visibles. ¡Agenda tu cita!"
        />

        {/* Keywords relevantes */}
        <meta
          name="keywords"
          content="dermicapro, clínica de piel, tratamientos faciales, cuidado de la piel, dermatología estética, HIFU 12D, pico láser, exosomas, ácido tranexámico, botox, hollywood peel, rejuvenecimiento facial, borrado de manchas, lifting sin cirugía, micropigmentación, clínica dermatológica trujillo"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dermicapro.com/" />
        <meta property="og:title" content="DermicaPro - Recupera la Confianza en tu Piel" />
        <meta property="og:description" content="Tratamientos especializados para el cuidado de tu piel. HIFU 12D, Pico Láser, Hollywood Peel y más. Resultados reales y profesionales." />
        <meta property="og:image" content="https://dermicapro.com/images/hero-1.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://dermicapro.com/" />
        <meta name="twitter:title" content="DermicaPro - Recupera la Confianza en tu Piel" />
        <meta name="twitter:description" content="Tratamientos especializados para el cuidado de tu piel. HIFU 12D, Pico Láser, Hollywood Peel y más." />
        <meta name="twitter:image" content="https://dermicapro.com/images/hero-1.png" />

        {/* Canonical URL */}
        <link rel="canonical" content="https://dermicapro.com/" />

        {/* Schema.org para Google - LocalBusiness */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "name": "DermicaPro",
            "image": "https://dermicapro.com/logo512.png",
            "description": "Clínica especializada en cuidado de la piel y tratamientos estéticos. HIFU 12D, Pico Láser, Exosomas con Ácido Tranexámico, Botox, Hollywood Peel, enzimas recombinantes, micropigmentación y más tratamientos profesionales.",
            "url": "https://dermicapro.com",
            "telephone": "+51974637783",
            "email": "contacto@dermicapro.com",
            "priceRange": "$$",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Av. Larco 877, San Andres V etapa",
              "addressLocality": "Trujillo",
              "addressRegion": "La Libertad",
              "addressCountry": "PE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "-8.137369",
              "longitude": "-79.052671"
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "09:00",
                "closes": "19:00"
              },
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": "09:00",
                "closes": "14:00"
              }
            ],
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "reviewCount": "2"
            }
          })}
        </script>
        

        {/* Schema.org - Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "DermicaPro",
            "url": "https://dermicapro.com",
            "logo": "https://dermicapro.com/logo512.png",
            "sameAs": [
              "https://www.facebook.com/profile.php?id=61570893266230",
              "https://www.instagram.com/dermicapro/"
            ]
          })}
        </script>

        {/* Schema.org - WebSite con SearchAction */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "DermicaPro",
            "url": "https://dermicapro.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://dermicapro.com/servicios?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          })}
        </script>
      </Helmet>

    <div className="animate-fade-in">

      <section className="relative h-screen flex items-center justify-center text-center overflow-hidden">
        {carouselItems.map((item, index) => (
          <div
            key={index}
            className="absolute inset-0 w-full h-full transition-opacity duration-1000 ease-in-out"
            style={{ opacity: index === currentSlide ? 1 : 0 }}
          >
            {item.type === "image" ? (
              <div
                className="w-full h-full bg-cover bg-center"
                style={{ backgroundImage: `url(${item.src})` }}
              />
            ) : (
              <video
                className="w-full h-full object-cover"
                src={item.src}
                autoPlay
                loop
                muted
                playsInline
              />
            )}
          </div>
        ))}

        <div className="absolute inset-0 bg-black opacity-50"></div>

        <div className="relative z-10 px-6 max-w-7xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight max-w-6xl mx-auto mb-6">
            ¿Cansada de gastar en cremas que no eliminan tus manchas ni tu flacidez?
          </h1>
          <p className="mt-6 text-base sm:text-lg md:text-xl text-gray-200 max-w-5xl mx-auto leading-relaxed">
            Sabemos lo frustrante que es invertir tiempo y dinero sin ver cambios reales.
            Aquí encontrarás tecnología profesional y un equipo que te explica con honestidad
            qué sí funciona para tu piel.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center items-center gap-4">
            <button
              onClick={openAdvisor}
              className="inline-block bg-brand-500 text-white font-bold py-3 px-8 rounded-full text-lg hover:bg-brand-600 transition-transform transform hover:scale-105 flex items-center"
            >
              {" "}
              <SparklesIcon className="w-5 h-5 mr-2" /> Recibir orientación
              honesta{" "}
            </button>
            <Link
              to="/servicios"
              className="inline-block bg-white text-brand-500 font-bold py-3 px-8 rounded-full text-lg hover:bg-gray-100 transition-transform transform hover:scale-105"
            >
              {" "}
              Conoce tu tratamiento ideal{" "}
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 flex space-x-3">
          {carouselItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === currentSlide
                  ? "bg-white"
                  : "bg-white/50 hover:bg-white"
              }`}
            />
          ))}
        </div>
      </section>
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              Tratamientos que sí funcionan para manchas, flacidez y marcas
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Ya probaste suficientes productos que prometen milagros.
              Aquí te explicamos con honestidad qué necesita tu piel y cómo lo logramos.
            </p>
          </div>
          <div className="mt-12 grid gap-8 md:grid-cols-3">
            {featuredServices.map((service) => (
              <div
                key={service.name}
                className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300"
              >
                <img
                  className="h-56 w-full object-cover"
                  src={service.img}
                  alt={service.name}
                />
                <div className="p-6">
                  {" "}
                  <h3 className="text-xl font-semibold text-gray-900">
                    {service.name}
                  </h3>{" "}
                  <p className="mt-2 text-gray-600">{service.desc}</p>{" "}
                  <Link
                    to="/servicios"
                    className="mt-4 text-brand-500 hover:text-brand-600 font-semibold"
                  >
                    Descubre si es para ti &rarr;
                  </Link>{" "}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              Ellas también dudaban antes de venir
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Personas que ya probaron otros métodos sin éxito.
              Hoy recuperaron la confianza que les faltaba.
            </p>
          </div>
          <div className="mt-12 grid gap-8 md:grid-cols-2">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.name}
                className="bg-gray-50 p-8 rounded-lg shadow-sm"
              >
                {" "}
                <div className="flex items-center mb-4">
                  {" "}
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <StarIcon key={i} className="w-5 h-5 text-brand-500" />
                  ))}{" "}
                </div>{" "}
                <blockquote className="text-gray-600 italic">
                  "{testimonial.quote}"
                </blockquote>{" "}
                <p className="mt-4 font-bold text-gray-900">
                  - {testimonial.name}
                </p>{" "}
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            {" "}
            <Link
              to="/testimonios"
              className="text-brand-500 hover:text-brand-600 font-semibold"
            >
              Leer más historias de confianza &rarr;
            </Link>{" "}
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default HomePage;
